import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const TicketActivityLog = () => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState('today');

  useEffect(() => {
    fetchActivities();
  }, [filter]);

  const fetchActivities = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const tenantId = localStorage.getItem('tenantId') || 'sevenwonders';
      
      const response = await axios.post(`${API_BASE_URL}/api/ticket-verification/bulk-status`, {
        date: filter === 'today' ? new Date().toISOString().split('T')[0] : null,
        tenantId
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      // Extract activities from bookings
      const allActivities = [];
      response.data.bookings?.forEach(booking => {
        if (booking.activityLog) {
          booking.activityLog.forEach(log => {
            allActivities.push({
              ...log,
              bookingId: booking.bookingId,
              customerName: booking.customerDetails?.name
            });
          });
        }
      });
      
      // Sort by timestamp desc
      allActivities.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
      setActivities(allActivities.slice(0, 20)); // Show last 20 activities
    } catch (error) {
      console.error('Failed to fetch activities:', error);
    } finally {
      setLoading(false);
    }
  };

  const getActionIcon = (action) => {
    switch (action) {
      case 'check-in': return '🟢';
      case 'check-out': return '🔴';
      case 'admin-override': return '⚠️';
      case 'admin-reset': return '🔄';
      default: return '📝';
    }
  };

  const getActionColor = (action) => {
    switch (action) {
      case 'check-in': return '#10b981';
      case 'check-out': return '#f59e0b';
      case 'admin-override': return '#ef4444';
      case 'admin-reset': return '#6366f1';
      default: return '#64748b';
    }
  };

  return (
    <div style={{
      background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
      borderRadius: '20px',
      padding: '24px',
      boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
      border: '1px solid rgba(226, 232, 240, 0.8)'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px'
      }}>
        <h3 style={{
          fontSize: '20px',
          fontWeight: '800',
          color: '#1a202c',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          margin: 0
        }}>
          📊 Activity Log
        </h3>
        <select
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          style={{
            padding: '8px 12px',
            border: '2px solid #e2e8f0',
            borderRadius: '8px',
            fontSize: '14px',
            background: 'white'
          }}
        >
          <option value="today">Today</option>
          <option value="week">This Week</option>
          <option value="all">All Time</option>
        </select>
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: '40px', color: '#64748b' }}>
          ⏳ Loading activities...
        </div>
      ) : activities.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '40px', color: '#64748b' }}>
          📝 No activities found
        </div>
      ) : (
        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
          {activities.map((activity, index) => (
            <div
              key={index}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                padding: '12px 16px',
                marginBottom: '8px',
                background: 'rgba(255, 255, 255, 0.8)',
                borderRadius: '12px',
                border: '1px solid rgba(226, 232, 240, 0.6)',
                transition: 'all 0.2s ease'
              }}
            >
              <div style={{
                fontSize: '20px',
                width: '32px',
                textAlign: 'center'
              }}>
                {getActionIcon(activity.action)}
              </div>
              
              <div style={{ flex: 1 }}>
                <div style={{
                  fontSize: '14px',
                  fontWeight: '600',
                  color: getActionColor(activity.action),
                  textTransform: 'capitalize'
                }}>
                  {activity.action.replace('-', ' ')}
                </div>
                <div style={{
                  fontSize: '13px',
                  color: '#64748b',
                  marginTop: '2px'
                }}>
                  {activity.customerName} • {activity.bookingId}
                </div>
                {activity.location && (
                  <div style={{
                    fontSize: '12px',
                    color: '#94a3b8',
                    marginTop: '2px'
                  }}>
                    📍 {activity.location}
                  </div>
                )}
              </div>
              
              <div style={{
                textAlign: 'right',
                fontSize: '12px',
                color: '#64748b'
              }}>
                <div>{new Date(activity.timestamp).toLocaleTimeString()}</div>
                <div style={{ fontSize: '11px', color: '#94a3b8' }}>
                  {activity.staffName || 'System'}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TicketActivityLog;